import { render, staticRenderFns } from "./MyOutletCollections.vue?vue&type=template&id=c984b8fc&scoped=true&"
import script from "./MyOutletCollections.vue?vue&type=script&lang=js&"
export * from "./MyOutletCollections.vue?vue&type=script&lang=js&"
import style0 from "./MyOutletCollections.vue?vue&type=style&index=0&id=c984b8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c984b8fc",
  null
  
)

export default component.exports